
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoujjaincab() {



    const cardData =
    {
        keyword: 'Pune to Ujjain Cab',
        heading: 'Meghana Cab : Pune to Ujjain Cab ',
        headingDescription: 'Meghana Cab offers Pune to Ujjain Cab services, providing a safe, comfortable, and spiritual travel experience to one of India’s most sacred pilgrimage destinations. Covering around 620 kilometers, our professional chauffeurs ensure a smooth and relaxed journey from Pune to the revered Mahakaleshwar Jyotirlinga Temple in Ujjain. Choose from our range of air-conditioned sedans, SUVs, and tempo travellers, all maintained for long-distance comfort and reliability. Whether you’re traveling for a religious yatra, family visit, or leisure trip, Meghana Cab guarantees punctual service, transparent fares, and 24×7 customer assistance. Book your Pune to Ujjain Cab with Meghana Cab for a peaceful, affordable, and spiritually enriching journey.',


        top: 'Top Places to Visit in Ujjain with Meghana Cab',

"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga Temple",
    "description": "The Mahakaleshwar Temple is the heart and soul of Ujjain, one of the twelve sacred Jyotirlingas of Lord Shiva. Situated on the banks of the holy Shipra River, this temple is the only south-facing Jyotirlinga, symbolizing Shiva as Mahakaal – the Lord of Time and Death. Its towering spire, ornate carvings, and daily rituals radiate divine power. The early morning Bhasma Aarti, performed with sacred ash, is a mesmerizing spiritual experience that draws thousands of devotees daily. The rhythmic chanting of mantras and the temple’s mystical aura make it a must-visit destination for spiritual seekers worldwide."
  },
  {
    "title": "Shree Kal Bhairav Temple",
    "description": "Dedicated to Kal Bhairav, the fierce manifestation of Lord Shiva, this temple is among Ujjain’s most enigmatic and ancient shrines. Kal Bhairav is considered the guardian deity of Ujjain, and offerings of liquor are a unique part of the rituals here, symbolizing liberation from fear and ego. The temple’s dark sanctum and continuous chanting create a trance-like atmosphere. Devotees believe visiting this temple protects them from negative energies. The spiritual intensity and centuries-old traditions make it one of Ujjain’s most intriguing and unforgettable pilgrimage experiences."
  },
  {
    "title": "Ram Ghat on River Shipra",
    "description": "Ram Ghat, located along the sacred Shipra River, is one of Ujjain’s oldest and most vibrant bathing ghats. Pilgrims gather here to take a holy dip, especially during Kumbh Mela, when millions of devotees from across the world converge for spiritual purification. The ghat is lined with ancient temples, ghanta ghars, and saffron-clad sadhus chanting Vedic hymns. Evenings at Ram Ghat are enchanting, with the Ganga Aarti illuminating the river with flickering diyas. The peaceful sound of bells and flowing water fills the atmosphere with devotion, making it an ideal place for meditation and reflection."
  },
  {
    "title": "Harsiddhi Mata Temple",
    "description": "Harsiddhi Mata Temple is one of Ujjain’s 51 Shakti Peethas and holds deep religious significance. According to legend, Goddess Sati’s elbow fell here, making it a powerful center of divine feminine energy. The temple’s twin red towers, adorned with oil lamps (deep-stambhs), create a mesmerizing view during evening aarti. Devotees visit to seek strength, prosperity, and blessings for success in life. The temple’s courtyard is always filled with spiritual energy and devotional music. It stands as a symbol of faith and balance between the forces of creation and destruction."
  },
  {
    "title": "Sandipani Ashram",
    "description": "Sandipani Ashram is an ancient gurukul where Lord Krishna, along with Balarama and Sudama, received spiritual and worldly education from Guru Sandipani. The ashram houses the sacred Gomati Kund, believed to have been created by Krishna to supply holy waters from all pilgrimages. The peaceful campus preserves the traditions of Vedic learning, meditation, and discipline. Visitors can explore carved stones, shrines, and relics linked to the Mahabharata era. Surrounded by greenery and silence, Sandipani Ashram offers an inspiring glimpse into India’s ancient education system and timeless spiritual heritage."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description": "Situated near the Mahakaleshwar Temple, Bade Ganeshji Ka Mandir is renowned for its massive idol of Lord Ganesha, symbolizing wisdom and prosperity. The temple also houses idols of Nandi and Hanuman, making it a hub of devotion. Devotees visit before offering prayers at Mahakaleshwar to seek the Lord’s blessings for success. The temple’s calm ambiance and beautiful murals depicting scenes from Hindu mythology make it visually and spiritually enriching. Regular recitations of Ganapati Atharvashirsha add to the divine vibrations of this holy site."
  },
  {
    "title": "Chintaman Ganesh Temple",
    "description": "Chintaman Ganesh Temple, located on the outskirts of Ujjain along the Shipra River, is one of the oldest and most revered Ganesha temples in India. The deity here is believed to be self-manifested (Swayambhu) and removes all forms of anxiety (‘chinta’). The temple’s ancient architecture, carved pillars, and peaceful surroundings make it a perfect place for prayer and introspection. Devotees believe that a single visit here can remove life’s troubles and bring calmness. The spiritual serenity and scenic riverside setting make it a must-visit for pilgrims and tourists alike."
  },
  {
    "title": "Mangalnath Temple",
    "description": "Perched on a small hill overlooking the Shipra River, Mangalnath Temple is believed to be the birthplace of Lord Mangal (Mars). According to the Matsya Purana, it is also considered the spot where Lord Shiva destroyed the demon Andhakasura. The temple offers stunning sunrise views and an open sky ideal for astronomical observations. It holds great importance for astrology followers, as special poojas are performed here to reduce the malefic effects of the planet Mars. The surrounding landscape and spiritual energy make Mangalnath an essential stop on the Ujjain pilgrimage circuit."
  },
  {
    "title": "Vikram Kirti Mandir and Planetarium",
    "description": "Vikram Kirti Mandir, named after the legendary King Vikramaditya, serves as both a museum and a cultural memorial celebrating Ujjain’s historical glory. The complex includes the Vikram University Planetarium, where astronomical shows explain the city’s ancient association with timekeeping and astrology. Exhibits include artifacts, manuscripts, and sculptures tracing Ujjain’s role in science, art, and literature. Visitors also find displays related to Kalidas, the great Sanskrit poet. It’s a perfect place for families and history lovers to connect with the intellectual and cultural grandeur of Ujjain."
  },
  {
    "title": "Kumbh Mela (Simhastha Ujjain)",
    "description": "Held once every 12 years, the Simhastha Kumbh Mela in Ujjain is one of the world’s largest religious gatherings, attracting millions of devotees, saints, and spiritual leaders. The event is celebrated when Jupiter enters the Leo (Simha) zodiac sign. During this time, the ghats of the Shipra River transform into a sea of saffron as pilgrims take holy dips for spiritual purification. Akharas perform processions, chanting fills the air, and cultural programs celebrate India’s spiritual diversity. Experiencing Kumbh in Ujjain is not just a pilgrimage—it’s a once-in-a-lifetime immersion into faith, tradition, and cosmic energy."
  }
],

         "services": [
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Meghana Cab is recognized as one of the best outstation cab services in Pune, offering reliable and comfortable travel solutions for every journey. Whether you’re heading to a nearby hill station, pilgrimage site, or business destination, our fleet includes well-maintained sedans, SUVs, Ertiga, and Innova Crysta cabs. Enjoy 24/7 booking support, professional chauffeurs, transparent pricing, and customizable one-way or round-trip options across India."
    },
    {
      "name": "Outstation Cab Service in Pune",
      "description": "Experience hassle-free long-distance travel with Meghana Cab’s outstation cab service in Pune. Ideal for family tours, business trips, and weekend getaways, we provide safe, air-conditioned vehicles and courteous drivers who ensure your comfort throughout the journey. Choose from flexible travel plans, including one-way and round-trip packages to destinations like Nashik, Shirdi, Mahabaleshwar, Ujjain, and Goa."
    },
    {
      "name": "Book Outstation Cabs Pune",
      "description": "Book outstation cabs from Pune easily with Meghana Cab’s online platform. Select from a variety of vehicle types based on your group size and comfort preferences. Our service ensures timely pickup, neat vehicles, and professional drivers for smooth intercity travel. Enjoy budget-friendly rates, reliable service, and instant confirmations for your next outstation trip."
    },
    {
      "name": "Outstation Taxi in Pune",
      "description": "Looking for a dependable outstation taxi in Pune? Meghana Cab provides well-maintained taxis for one-way or multi-day trips to major cities and tourist destinations. Our vehicles are equipped with all comfort amenities, and our drivers are trained for long-distance travel, ensuring your journey is safe, relaxed, and enjoyable."
    },
    {
      "name": "Outstation Taxi Service in Pune",
      "description": "Travel worry-free with Meghana Cab’s trusted outstation taxi service in Pune. Whether you’re planning a pilgrimage to Shirdi, a family trip to Mahabaleshwar, or a business visit to Mumbai or Ujjain, our cabs are ready to serve. Enjoy flexible routes, AC comfort, affordable pricing, and experienced drivers who prioritize your safety and satisfaction."
    },
    {
      "name": "Pune to Ujjain Cab Booking",
      "description": "Book your cab from Pune to Ujjain with Meghana Cab for a comfortable and peaceful spiritual journey. Our drivers are well-versed with routes to Ujjain and Omkareshwar, ensuring timely arrivals. Choose from sedans, Ertiga, and Innova Crysta cabs for solo travelers, families, or groups. We offer one-way and round-trip bookings at affordable fares."
    },
    {
      "name": "Pune to Ujjain Innova Crysta",
      "description": "Travel luxuriously from Pune to Ujjain in an Innova Crysta cab by Meghana Cab. Ideal for long-distance comfort, this cab offers premium seating, ample space, and smooth performance. Perfect for family tours or pilgrimage visits to Mahakaleshwar Temple and Omkareshwar, our service guarantees a relaxed and secure ride."
    },
    {
      "name": "Pune to Ujjain Tour Package",
      "description": "Embark on a spiritually fulfilling Pune to Ujjain tour package with Meghana Cab. Visit the sacred Mahakaleshwar Jyotirlinga Temple and explore nearby sites like Omkareshwar. Our packages include comfortable cab transfers, professional drivers, and customizable itineraries, ideal for families, senior citizens, and devotional groups."
    },
    {
      "name": "Pune to Ujjain Tour Package for Family",
      "description": "Plan a memorable family pilgrimage with Meghana Cab’s Pune to Ujjain family tour package. This package is designed for convenience and comfort, covering Mahakaleshwar Temple, Omkareshwar, and local sightseeing. Enjoy AC cab travel, flexible pickup points, and courteous drivers who ensure a smooth experience for all family members."
    },
    {
      "name": "Pune to Ujjain Omkareshwar Tour Package",
      "description": "Meghana Cab offers a combined Pune to Ujjain and Omkareshwar tour package for spiritual travelers. Visit two of India’s revered Jyotirlinga temples in one trip. Our package includes clean, air-conditioned cabs, expert drivers, and flexible scheduling options for a stress-free devotional journey."
    },
    {
      "name": "Pune to Indore Cab",
      "description": "Book a comfortable cab from Pune to Indore with Meghana Cab. Enjoy a seamless intercity travel experience with our spacious and air-conditioned cars. Whether traveling for business, family visits, or connecting to Ujjain, our professional drivers and affordable fares make your trip safe and convenient."
    },
    {
      "name": "Pune to Mahakaleshwar Ujjain Cab",
      "description": "Travel from Pune to the holy Mahakaleshwar Temple in Ujjain with Meghana Cab’s dedicated taxi service. Our cabs offer comfortable seating, AC facilities, and punctual service. Choose from Ertiga, Sedan, or Innova Crysta based on your group size and budget for a serene pilgrimage experience."
    },
    {
      "name": "Pune to Mahakaleshwar Ujjain Ertiga Cab",
      "description": "Meghana Cab provides comfortable and affordable Ertiga cab service from Pune to Mahakaleshwar Temple in Ujjain. Ideal for small families or groups, our Ertiga cabs ensure spacious seating and smooth travel over long distances. Experience a relaxed devotional trip with reliable service and transparent pricing."
    },
    {
      "name": "Pune to Ujjain Jyotirlinga Cab Service",
      "description": "Book your Pune to Ujjain Jyotirlinga cab with Meghana Cab for a comfortable and sacred pilgrimage. Our cabs are equipped with AC comfort, experienced drivers, and flexible itineraries that can include Omkareshwar or Indore. Enjoy a smooth, peaceful travel experience focused on your spiritual journey."
    },
    {
      "name": "Pune to Ujjain Jyotirlinga Innova Crysta",
      "description": "Experience luxury travel to Mahakaleshwar Jyotirlinga in Ujjain with our Pune to Ujjain Innova Crysta service. Perfect for families and groups, the Crysta offers a comfortable ride with superior interiors and ample luggage space. Our professional chauffeurs ensure your trip remains safe and relaxing throughout."
    },
    {
      "name": "Pune to Ujjain Jyotirlinga Sedan Cab Service",
      "description": "Travel economically from Pune to Ujjain in a sedan cab by Meghana Cab. Our sedans are ideal for solo travelers and couples looking for an affordable yet comfortable journey to Mahakaleshwar Jyotirlinga. Enjoy smooth highway travel, AC comfort, and door-to-door service for a seamless spiritual experience."
    }
  ],
  "tableData": [
    ["Best Outstation Cab Service in Pune", "Outstation Cab Service in Pune"],
    ["Book Outstation Cabs Pune", "Outstation Taxi in Pune"],
    ["Outstation Taxi Service in Pune", "Pune to Ujjain Cab Booking"],
    ["Pune to Ujjain Innova Crysta", "Pune to Ujjain Tour Package"],
    ["Pune to Ujjain Tour Package for Family", "Pune to Ujjain Omkareshwar Tour Package"],
    ["Pune to Indore Cab", "Pune to Mahakaleshwar Ujjain Cab"],
    ["Pune to Mahakaleshwar Ujjain Ertiga Cab", "Pune to Ujjain Jyotirlinga Cab Service"],
    ["Pune to Ujjain Jyotirlinga Innova Crysta", "Pune to Ujjain Jyotirlinga Sedan Cab Service"]
  ],










"whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Ujjain Cab Service",
        "WhyChoosedescription": "Meghana Cab provides reliable and comfortable cab services from Pune to Ujjain, ideal for spiritual journeys to Mahakaleshwar Jyotirlinga or family visits."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop at Ujjain",
        "WhyChoosedescription": "We ensure timely pick-up from Pune and smooth drop-off in Ujjain, so you can attend darshan, rituals, or personal events without delays."
    },
    {
        "WhyChooseheading": "Expert Drivers for Long-Distance Travel",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the Pune to Ujjain route and prioritize safe, efficient, and comfortable travel."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Meghana Cab offers transparent and competitive cab fares from Pune to Ujjain, making long-distance travel economical and hassle-free."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles for Your Journey",
        "WhyChoosedescription": "Travel in clean, sanitized cabs equipped with GPS, seat belts, and emergency support to ensure a secure journey for all passengers."
    },
    {
        "WhyChooseheading": "24/7 Cab Service from Pune to Ujjain",
        "WhyChoosedescription": "Our cabs are available round the clock, whether you’re planning an overnight trip, early morning departure, or return from Ujjain late at night."
    },
    {
        "WhyChooseheading": "Flexible Travel Plans and Stops",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-stop packages. You can include Indore, Omkareshwar, or other nearby places along your route."
    },
    {
        "WhyChooseheading": "Quick Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Pune to Ujjain cab with ease through our website or app. Our support team is available 24/7 to assist you with bookings and travel queries."
    }
]


























    }





const faqData = [
    {
        question: "How can I book a Pune to Ujjain cab with Meghana Cab?",
        answer: "You can book a Pune to Ujjain cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Ujjain?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Ujjain trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one‑way cab service available from Pune to Ujjain?",
        answer: "Yes, we offer both one‑way and round‑trip cab services from Pune to Ujjain."
    },
    {
        question: "How long does it take to travel from Pune to Ujjain by cab?",
        answer: "The journey typically takes **13 to 15 hours**, depending on traffic, route and halts. :contentReference[oaicite:0]{index=0}"
    },
    {
        question: "What is the distance between Pune and Ujjain by road?",
        answer: "The distance is around **680‑710 km** depending on the route taken. :contentReference[oaicite:1]{index=1}"
    },
    {
        question: "Are tolls, parking, and taxes included in the cab fare for Pune to Ujjain?",
        answer: "Tolls, state taxes, and parking charges are additional and will be clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for long‑distance travel like Pune to Ujjain?",
        answer: "Yes, our drivers are professional, well‑experienced, and familiar with outstation routes including Pune to Ujjain."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Ujjain journey?",
        answer: "Yes, you can request halts or breaks during the trip. Please mention them while booking."
    },
    {
        question: "Is the cab service from Pune to Ujjain available at night?",
        answer: "Yes, Meghana Cab offers 24/7 service, so you can plan your journey at night or early morning as needed."
    },
    {
        question: "What payment options are accepted for Pune to Ujjain cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Ujjain cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Manoj Singh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Ujjain ride with Meghana Cab was comfortable and well‑planned. The driver was punctual, the car clean, and we were able to make good breaks along the way.”',
    },
    {
        name: 'Mrs. Pooja Rathi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Safe journey, excellent service. Although it was a long trip, Meghana Cab made it stress‑free and pleasant.”',
    },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Cab",
  "description": "Book reliable Pune to Ujjain cab service with Meghana Cabs. Comfortable outstation taxis including Innova Crysta and sedan options for family trips, religious tours to Mahakaleshwar, Omkareshwar, and Jyotirlinga visits.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3785"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Ujjain Cab | Outstation Taxi & Tour Packages @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Ujjain cab with Meghana Cabs for comfortable outstation taxi service. Perfect for family tours, religious visits to Mahakaleshwar and Omkareshwar, and Jyotirlinga temple trips."
  />
  <meta
    name="keywords"
    content="Best outstation cab service in pune, Outstation cab service in pune, Book outstation cabs pune, Outstation taxi in pune, Outstation taxi service in pune, pune to ujjain cab booking, pune to ujjain innova crysta, pune to ujjain tour package, pune to ujjain tour package for family, pune to ujjain trip package, pune to ujjain omkareshwar tour package, pune to indore cab, pune to mahakaleshwar ujjain cab, pune to mahakaleshwar ujjain ertiga cab, pune to mahakaleshwar ujjain cab, pune to ujjain jyotirlinga cab service, pune to ujjain jyotirlinga innova crysta, pune to ujjain jyotirlinga sedan cab service"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>





            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoujjaincab;